export default __webpack_public_path__ + "static/media/fontRoboto700_greek_ext.bd9854c7.woff2";